 export function toFormData(o) {
    const formData = new FormData();
    for (let [key, value] of Object.entries(o)) {
        if (value !== undefined) {
            if (value == null) {
                value = "";
            }
            formData.append(key, value);
            continue;
        }
    }
    return formData;
  }
  


// WEBPACK FOOTER //
// ./src/common/descriptions.js